import styled from 'styled-components';

export const AnswerFormStyled = styled.div`
  .answer_row {
    margin-bottom: 0.5rem;
    display: flex;
    column-gap: 1rem;
  }
`;
